// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lBiGt","content":"_2sERm","figure-caption":"_2hix2","image-attribute":"_15G33","image-caption":"_3R-CL"};